module.exports = __webpack_public_path__ + "static/media/CreditCard.33798fa1.svg";